<template>
  <div>
    <center>
      <v-card class="mx-auto" max-width="100%">
        <v-card class="text-center">
          <v-img height="100%" :src="imageNormalLate"></v-img>
          <div class="text-h5 text--primary">
            {{ shiftItem.empFull_NameTH }}
          </div>
          <div class="text--primary">
            วันที่ {{ shiftItem.checkInDay }}-{{ shiftItem.checkInMonth }}-
            {{ shiftItem.checkInYear }}
          </div>
          <div class="text--primary" v-if="shiftItem.checkInStartStamp">
            ท่านได้บันทึก เวลาเข้างาน {{ shiftItem.checkInStartStamp }}
            <v-icon color="green darken-2" v-if="textNormalLate ==='ปกติ' ">mdi-thumb-up</v-icon>
            <v-icon color="red darken-2" v-else>mdi-thumb-down</v-icon>
          </div>
          <div class="text--primary" v-if="shiftItem.checkInEndStamp">
            ท่านได้บันทึก เวลาออกงาน {{ shiftItem.checkInEndStamp }} <v-icon color="green darken-2">mdi-thumb-up</v-icon>
          </div>

          <v-divider style="background-color: #ffffff"></v-divider>

          <v-card-text class="font-weight-bold">
            {{ captionName }}
          </v-card-text>

          <v-divider style="background-color: #ffffff"></v-divider>
          <!-- <v-btn
            class="ma-2 white--text"
            large
            color="#068000"
            @click="home()"
          >

            ประวัติเข้าออกงาน
          </v-btn> -->
          <v-btn
            class="ma-2 white--text"
            large
            color="#262A34"
            @click="close()"
          >
            ปิดหน้าต่างนี้
          </v-btn>
        </v-card>
      </v-card>
    </center>
  </div>
</template>
<script>
import { gmapApi } from 'vue2-google-maps'
// import axios from 'axios'
// import moment from 'moment' // แปลง date
// import VuetifyLogo from '../logo'
export default {
  components: {
    gmapApi
  },
  name: 'CheckINSuccess',
  beforeCreate () {
    this.$liff.init({ liffId: this.$liff_checkinout }, function (data) {})
  },
  created () {
    // setInterval(this.getNow, 1000)
  },
  data () {
    return {
      shiftItem: [],
      imageNormalLate: '',
      textNormalLate: 'ท่านได้ลงเวลาเข้างานสำเร็จ',
      imageNormal: '',
      imageUrl: '',
      caption: '',
      imageUrlCheckin: '',
      imageUrlCheckout: '',
      captionName: ''
    }
  },
  async mounted () {
    this.imageUrl = require('@/assets/Icon/Check-in.png')
    this.imageUrlCheckout = require('@/assets/Icon/GroupCheckout.jpg')
    this.imageUrlCheckin = require('@/assets/Icon/GroupCheckin.jpg')
    this.imageNormalLate = require('@/assets/Icon/Normal.jpg')
    this.imageNormal = require('@/assets/Icon/Normal.jpg')

    this.shiftItem = JSON.parse(localStorage.getItem('check_shiftItem'))
    this.captionName = localStorage.getItem('caption')
    this.textNormalLate = localStorage.getItem('textNormalLate')
    if (this.textNormalLate === 'สาย') {
      this.imageNormalLate = require('@/assets/Icon/late.jpg')
    }
  },
  methods: {
    close () {
      // if (this.$route.query.checkStatus === 'IN') {
      //   window.open('https://liff.line.me/1654154168-6Jl04b87?token=1')
      // }
      // window.open('line://app/1654154168-6Jl04b87?token=1')
      this.$liff.closeWindow()
    }
    // close () {
    //   this.$liff.openWindow({
    //     url: 'line://app/1654154168-6Jl04b87?token=1',
    //     external: true
    //   })
    // }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/CheckinSuccess.vue